import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function OpsProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loggedOut, setLoggedOut] = useState(false);
  const check = useCallback(async () => {
    try {
      setMe((await api.get("/ops/auth/me")).data);
    } catch (e) {
      setMe(false);
    }
  }, []);
  useEffect(() => {
    check();
  }, [check]);
  const logout = async () => {
    const admin = me?.kind === "admin";
    await api.post(admin ? "/auth/logout" : "/ops/auth/logout").catch(() => {});
    sessionStorage.removeItem("ops_next");
    setLoggedOut(true);
    setMe(false);
  };
  return <Ctx.Provider value={{ me, setMe, check, logout, loggedOut, setLoggedOut }}>{children}</Ctx.Provider>;
}

export const useOps = () => useContext(Ctx);
